<template>
  <div>
    <el-form :model="formData" :disabled="disabled" :rules="required ? rules() : {}" ref="addressForm">
      <!-- line1、line2 -->
      <el-form-item style="margin-bottom: 25px;" :label="''" prop="address1">
        <el-input maxlength="100" v-model="formData.address1" :placeholder="$t('message.refuse.klarnaRebutDrawer.address.line1Placeholder')"></el-input>
      </el-form-item>
      <el-form-item :label="''" prop="address2">
        <el-input maxlength="100" v-model="formData.address2" :placeholder="$t('message.refuse.klarnaRebutDrawer.address.line2Placeholder')"></el-input>
      </el-form-item>

      <div style="display: flex;justify-content: space-between;gap: 16px;">
        <el-form-item style="flex: 1;" :label="$t('message.refuse.klarnaRebutDrawer.address.city')" prop="city">
          <el-input maxlength="50" v-model="formData.city"></el-input>
        </el-form-item>
        <el-form-item style="flex: 1;" :label="$t('message.refuse.klarnaRebutDrawer.address.state')" prop="state">
          <el-input maxlength="50" v-model="formData.state"></el-input>
        </el-form-item>
      </div>
      <div style="display: flex;justify-content: space-between;gap: 16px;">
        <el-form-item style="flex: 1;" :label="$t('message.refuse.klarnaRebutDrawer.address.postalCode')" prop="postalCode">
          <el-input maxlength="50" v-model="formData.postalCode"></el-input>
        </el-form-item>
        <el-form-item style="flex: 1;" :label="$t('message.refuse.klarnaRebutDrawer.address.country')" prop="country">
          <el-input maxlength="10" v-model="formData.country"></el-input>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import { rules } from './rules';
export default {
  props: {
    /**
     * 是否必填
     */
    required: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    rules,
    validate() {
      return this.$refs.addressForm.validate();
    },
  },
  computed: {
    formData: {
      get() {
        return this.data;
      },
      set(newValue) {
        this.$emit('update:data', newValue);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

:deep(.el-input__count) {
  background-color: transparent !important;
  color: #8D98AF !important;
}

:deep(.el-descriptions__body) {
  background-color: transparent !important;
}
</style>
